import { render } from "./IntegrationTab.vue?vue&type=template&id=0526b25c"
import script from "./IntegrationTab.vue?vue&type=script&lang=js"
export * from "./IntegrationTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__